import Home from '../pages/home/Home';
import Idecaba from '../pages/institutional/idecaba/Idecaba';
import Organitation from '../pages/institutional/organitation/Organitation';
import Regulations from '../pages/institutional/regulations/Regulations';
import OrganitationP from '../pages/institutional/organizationP/OrganitationP';
import Adhere from '../pages/institutional/adhere idecaba/Adhere';
import CatalogOg from '../pages/resources/catalog_og/CatalogOg';
import GeoservicesPage from '../pages/resources/geoservices/GeoservicesPage';
import Instructions from '../pages/resources/instructions/Instructions';
import Visor from '../pages/resources/visor/Visor';
import Contacto from '../pages/contacto/Contacto';

const routes = [
  { path: '/', component: Home, title: 'Inicio' },
  { path: 'Institucional/IDECABA', component: Idecaba, title: 'IDECABA' },
  { path: 'Institucional/Organizacion', component: Organitation, title: 'Organización' },
  { path: 'Institucional/Normativas', component: Regulations, title: 'Normativas' },
  { path: 'Institucional/Organismos-Participantes', component: OrganitationP, title: 'Organismos Participantes' },
  /* { path: 'Institucional/Adherirse-IDECABA', component: Adhere, title: 'Adherirse IDECABA' }, */
  { path: 'Recursos/Catalogo-de-Objetos-Geograficos', component: CatalogOg, title: 'CATALOGO DE OG (objetos geográficos) y de METADATOS' },
  { path: 'Recursos/Geoservicios', component: GeoservicesPage, title: 'Geoservicios' },
  /* { path: 'Recursos/Instructivos', component: Instructions, title: 'Instructivos' }, */
  { path: 'Recursos/Visor-de-Mapas', component: Visor, title: 'Visualizador' },
  { path: '/Contacto', component: Contacto, title: 'Contacto' },
];

export default routes;
